import { createContext, useContext, useEffect, useState } from "react";
import { contentService } from "../services/contentService";
import { LANDING_DEFAULTS } from "../utils/landingDefaults";

const Ctx = createContext(LANDING_DEFAULTS);

export const LandingContentProvider = ({ children }) => {
  const [content, setContent] = useState(LANDING_DEFAULTS);

  useEffect(() => {
    let cancelled = false;

    const params = new URLSearchParams(window.location.search);
    const isPreview = params.get("preview") === "1";

    if (isPreview) {
      try {
        const raw = sessionStorage.getItem("landingPreviewDraft");
        if (raw) {
          const draft = JSON.parse(raw);
          if (draft?.content) {
            setContent(draft.content);
            return () => {
              cancelled = true;
            };
          }
        }
      } catch (_) {
        // Fall through to API-backed content fetch.
      }
    }

    contentService
      .getContent()
      .then((data) => {
        if (!cancelled && data) setContent(data);
      })
      .catch(() => {
        /* keep defaults */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <Ctx.Provider value={content}>{children}</Ctx.Provider>;
};

export const useLandingContent = () => useContext(Ctx);
